import fireAnalytics from '~/services/analytics/fireAnalytics';

export const visitedGiftCards = () => fireAnalytics('Visited Gift Cards');

export const visitedPurchaseGiftCards = () =>
  fireAnalytics('Visited Purchase Gift Cards');

export const visitedRedeemGiftCard = () =>
  fireAnalytics('Visited Redeem Gift Card');

export const purchasedGiftCard = (amount: number) =>
  fireAnalytics('Purchased Gift Card', null, { amount });

export const redeemedGiftCard = (amount: number) =>
  fireAnalytics('Redeemed Gift Card', null, { amount });

export const visitedGiftCardPurchaseComplete = (amount: number) =>
  fireAnalytics('Visited Gift Card Purchase Complete', null, { amount });

export const printedGiftCard = () => fireAnalytics('Printed Gift Card');
